// Translations for English, German, French, Spanish
export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'es', label: 'Español', flag: '🇪🇸' }
];

export const CURRENCIES = [
  { code: 'INR', symbol: '₹', label: 'INR', rate: 1 },
  { code: 'EUR', symbol: '€', label: 'EUR', rate: 1 / 90 } // 1 INR = 1/90 EUR
];

// Region-specific shipping. Base amounts stored in INR (site's base currency).
export const SHIPPING_CONFIG = {
  INR: {
    freeShipThresholdINR: 999, // orders above ₹999 ship free
    shippingFeeINR: 99,
    deliveryDays: '6-7'
  },
  EUR: {
    freeShipThresholdINR: 4500, // €50 = ₹4500 base
    shippingFeeINR: 540,        // ~€6
    deliveryDays: '7-12'
  }
};

// Country -> {lang, currency}
export const COUNTRY_MAP = {
  IN: { lang: 'en', currency: 'INR' },
  DE: { lang: 'de', currency: 'EUR' },
  AT: { lang: 'de', currency: 'EUR' },
  CH: { lang: 'de', currency: 'EUR' },
  FR: { lang: 'fr', currency: 'EUR' },
  BE: { lang: 'fr', currency: 'EUR' },
  LU: { lang: 'fr', currency: 'EUR' },
  ES: { lang: 'es', currency: 'EUR' },
  MX: { lang: 'es', currency: 'EUR' },
  IT: { lang: 'en', currency: 'EUR' },
  NL: { lang: 'en', currency: 'EUR' },
  GB: { lang: 'en', currency: 'EUR' },
  US: { lang: 'en', currency: 'EUR' }
};

// EU + common markets VAT rates (mirrors backend vat_rates.py)
export const VAT_RATES = {
  AT: { rate: 20, name: 'Austria' },
  BE: { rate: 21, name: 'Belgium' },
  BG: { rate: 20, name: 'Bulgaria' },
  HR: { rate: 25, name: 'Croatia' },
  CY: { rate: 19, name: 'Cyprus' },
  CZ: { rate: 21, name: 'Czech Republic' },
  DK: { rate: 25, name: 'Denmark' },
  EE: { rate: 22, name: 'Estonia' },
  FI: { rate: 25.5, name: 'Finland' },
  FR: { rate: 20, name: 'France' },
  DE: { rate: 19, name: 'Germany' },
  GR: { rate: 24, name: 'Greece' },
  HU: { rate: 27, name: 'Hungary' },
  IE: { rate: 23, name: 'Ireland' },
  IT: { rate: 22, name: 'Italy' },
  LV: { rate: 21, name: 'Latvia' },
  LT: { rate: 21, name: 'Lithuania' },
  LU: { rate: 17, name: 'Luxembourg' },
  MT: { rate: 18, name: 'Malta' },
  NL: { rate: 21, name: 'Netherlands' },
  PL: { rate: 23, name: 'Poland' },
  PT: { rate: 23, name: 'Portugal' },
  RO: { rate: 19, name: 'Romania' },
  SK: { rate: 23, name: 'Slovakia' },
  SI: { rate: 22, name: 'Slovenia' },
  ES: { rate: 21, name: 'Spain' },
  SE: { rate: 25, name: 'Sweden' },
  GB: { rate: 20, name: 'United Kingdom' },
  CH: { rate: 8.1, name: 'Switzerland' },
  NO: { rate: 25, name: 'Norway' },
  IS: { rate: 24, name: 'Iceland' },
  IN: { rate: 12, name: 'India' },
  US: { rate: 0, name: 'United States' },
  MX: { rate: 16, name: 'Mexico' }
};

export const DEFAULT_VAT_BY_CURRENCY = { EUR: 19, INR: 12 };

export const translations = {
  en: {
    // header / nav
    men: 'MEN', women: 'WOMEN', sneakers: 'SNEAKERS',
    account: 'Account', wishlist: 'Wishlist', bag: 'Bag',
    searchPlaceholder: 'What are you looking for?',
    theBrand: 'THE', brandName: 'FERON STORE',
    // sections
    topwear: 'TOPWEAR', bottomwear: 'BOTTOMWEAR', footwear: 'FOOTWEAR', accessories: 'ACCESSORIES', shopByStyle: 'SHOP BY STYLE', collections: 'COLLECTIONS',
    // offer strip
    offer1: 'FREE WORLDWIDE SHIPPING',
    offer2: 'SECURE PAYMENTS',
    offer3: '7 DAYS EASY EXCHANGES',
    offer4: 'BUY 3 GET 20% OFF | CODE: FERON20',
    // hero
    presents: 'FERON STORE PRESENTS',
    heroGrandTitle: 'GRAND OPENING', heroGrandSub: 'Welcome to a new beginning — step into the all-new Feron shopping experience.', heroGrandCta: 'START SHOPPING',
    hero1Title: 'THE BIG WINTER SALE', hero1Sub: '', hero1Cta: 'SHOP NOW',
    hero2Title: 'NEW DROPS ARE HERE', hero2Sub: 'Fresh styles, straight from the runway', hero2Cta: 'EXPLORE',
    hero3Title: 'STREETWEAR EDIT', hero3Sub: 'Own the streets', hero3Cta: 'SHOP THE EDIT',
    // home sections
    shopByCategory: 'SHOP BY CATEGORY',
    newArrivals: 'NEW ARRIVALS', bestSellers: 'BEST SELLERS', sneakerDrop: 'SNEAKER DROP',
    viewAll: 'VIEW ALL',
    officialMerch: 'OFFICIAL MERCHANDISE',
    officialMerchSub: "Licensed collabs with the world's biggest brands",
    // product card / listing
    off: 'OFF',
    products: 'products',
    filters: 'FILTERS', category: 'CATEGORY', price: 'PRICE', discount: 'DISCOUNT',
    upTo: 'up to', min: 'min',
    clearAll: 'CLEAR ALL',
    sortLabel: 'Sort',
    sortPopular: 'Popularity', sortNew: "What's New", sortPlh: 'Price: Low to High', sortPhl: 'Price: High to Low', sortDisc: 'Discount',
    noProducts: 'No products found. Try adjusting filters.',
    searchResults: 'Search',
    mensCollection: "MEN'S COLLECTION", womensCollection: "WOMEN'S COLLECTION", shopAll: 'SHOP ALL',
    // pdp
    home: 'Home', reviews: 'reviews',
    inclTaxes: 'Inclusive of all taxes',
    selectSize: 'SELECT SIZE', sizeChart: 'SIZE CHART',
    addToBag: 'ADD TO BAG', wishlistBtn: 'WISHLIST',
    pleaseSelectSize: 'Please select a size',
    checkDelivery: 'CHECK DELIVERY', enterPincode: 'Enter Pincode', checkBtn: 'CHECK',
    deliveryOk: 'Delivery available at {pin} in {days} days.',
    invalidPin: 'Enter a valid 6-digit pincode',
    freeShipping: 'Free Shipping', dayReturns: '30 Day Returns', securePayments: 'Secure Payments',
    productDetails: 'PRODUCT DETAILS',
    fabric: 'Fabric: 100% Cotton', fit: 'Fit: Oversized', pattern: 'Pattern: Printed', washCare: 'Wash Care: Machine wash cold, tumble dry low',
    youMayLike: 'YOU MAY ALSO LIKE',
    productNotFound: 'Product not found.', goHome: 'Go home',
    // cart
    myBag: 'MY BAG', items: 'items',
    emptyBag: 'Your bag is empty', emptyBagSub: 'Add some cool stuff to get started',
    continueShopping: 'CONTINUE SHOPPING',
    freeShipTag: 'Yay! You get FREE SHIPPING', addForFreeShip: 'Add {amount} more for FREE shipping',
    size: 'Size', remove: 'REMOVE',
    priceDetails: 'PRICE DETAILS', totalMrp: 'Total MRP', discountMrp: 'Discount on MRP',
    couponDiscount: 'Coupon Discount', shipping: 'Shipping', free: 'FREE',
    totalAmount: 'Total Amount', savingMsg: 'You are saving {amount} on this order',
    couponPlaceholder: 'Enter coupon (try FERON20)', apply: 'APPLY',
    couponApplied: 'Coupon applied!', savedAmount: 'You saved {amount}', invalidCoupon: 'Invalid coupon',
    placeOrder: 'PLACE ORDER',
    checkoutDemo: 'Checkout demo', checkoutDemoSub: 'This is a frontend demo. Backend checkout coming soon.',
    // wishlist
    myWishlist: 'MY WISHLIST',
    emptyWishlist: 'Your wishlist is empty', emptyWishlistSub: 'Save your favourites here for later',
    explore: 'EXPLORE PRODUCTS',
    // toasts
    addedToBag: 'Added to bag', addedToWishlist: 'Added to wishlist', removedFromWishlist: 'Removed from wishlist',
    // auth
    welcomeTo: 'WELCOME TO',
    loginSubtitle: 'Login / Signup with your mobile number',
    mobileNumber: 'MOBILE NUMBER', mobilePlaceholder: '10-digit mobile',
    sendOtp: 'SEND OTP', enterOtp: 'ENTER OTP (any 4 digits)', verifyLogin: 'VERIFY & LOGIN',
    changeNumber: 'Change number',
    termsText: "By continuing, I agree to Feron Store's Terms of Use & Privacy Policy",
    myAccount: 'My Account', welcomeBack: 'Welcome back,', logout: 'Logout',
    // footer
    needHelp: 'NEED HELP', company: 'COMPANY', moreInfo: 'MORE INFO', storeNearMe: 'STORE NEAR ME',
    contactUs: 'Contact Us', trackOrder: 'Track Order', returnsRefunds: 'Exchanges', faqs: 'FAQs', myAccountLink: 'My Account',
    aboutUs: 'About Us', investorRelation: 'Investor Relation', careers: 'Careers', giftVouchers: 'Gift Vouchers', community: 'Community Initiatives',
    tnc: 'T&C', privacyPolicy: 'Privacy Policy', sitemap: 'Sitemap', getNotified: 'Get Notified', blogs: 'Blogs',
    viewMore: 'View More',
    codAvailable: 'Secure Payments', easyReturns: '30 Days Easy Exchanges', freeShippingOver: 'Free Shipping over {amount}', freeShippingWorldwide: 'Free Worldwide Shipping', experienceApp: 'Experience Feron App',
    copyright: '© 2025 Feron Store. All rights reserved.',
    // switcher
    vatIncluded: 'VAT ({rate}%) included · Prices in EUR', vatLine: 'incl. VAT ({rate}%)',
    country: 'Country', language: 'Language', currency: 'Currency', save: 'Save',
    // care instructions
    careByLine: 'BY ASENA & HITVANSHI',
    careThankYou: 'Thank you for choosing our clothes and stepping into your superhero power — your style is your super strength! Every purchase you make helps you conquer the world with confidence and courage, and we are honored to be part of your heroic journey.',
    careInstructions: 'CARE INSTRUCTIONS',
    careTagline: 'Please follow these tips to ensure the item stays in good condition',
    care_coldWash: 'Cold Wash',
    care_noBleach: 'Do not bleach',
    care_noTumble: 'Do not tumble dry on low',
    care_ironMedium: 'Iron at medium heat',
    care_coldMachine: 'Cold machine wash',
    care_noIronPrint: 'Do not iron on print or embroidery',
    careFooterLeft: 'Elevate your every day with FERON',
    // About Us
    aboutTitle: 'Our Story',
    aboutHero: 'Feron Store was born from a simple idea — clothes that let you step into your own super-power. We design pieces that carry more than fabric: they carry attitude, courage and a bit of everyday magic.',
    aboutStoryTitle: 'How it started',
    aboutStoryP1: 'What began as a late-night sketchbook between two friends — Asena and Hitvanshi — quickly turned into a full-blown label. We loved streetwear that felt bold but personal, and we hated how mass-produced most of it felt.',
    aboutStoryP2: 'So we built Feron from the ground up: small runs, thoughtful details, prints inspired by the icons we grew up loving. Every piece ships from India + Europe and is made to be worn, loved, and lived-in.',
    aboutQuote: 'Your style is your super-strength — wear it like you mean it.',
    aboutQuoteAttribution: 'Asena & Hitvanshi, Founders',
    aboutValuesTitle: 'What we care about',
    aboutValue1Title: 'Made to last',
    aboutValue1Body: 'Heavier fabrics, honest stitches, prints that hold their color through wash after wash.',
    aboutValue2Title: 'Small batches',
    aboutValue2Body: 'No warehouse of dead stock. We drop capsules in small runs so every buyer gets something a little rare.',
    aboutValue3Title: 'Shipped worldwide',
    aboutValue3Body: 'India, Europe and beyond — with clear delivery windows and honest customs handling upfront.',
    aboutCtaTitle: 'Ready to wear the story?',
    aboutCtaBody: 'Browse the latest drop, or drop us a line — we love hearing from our people.',
    aboutCtaShop: 'SHOP THE DROP',
    aboutCtaContact: 'CONTACT US',
    // Contact Us
    contactTitle: 'Contact Us',
    contactSubtitle: "Questions, feedback, or just want to say hi — we'd love to hear from you.",
    contactEmail: 'Email',
    contactPhone: 'Phone',
    contactAddress: 'Address',
    contactName: 'Your Name',
    contactYourEmail: 'Your Email',
    contactSubject: 'Subject',
    contactMessage: 'Message',
    contactSend: 'SEND MESSAGE',
    contactFillRequired: 'Please fill your email and message',
    contactMailtoNote: "Clicking send will open your mail app with your message pre-filled — no data is sent through our servers.",
    // Track Order
    trackTitle: 'Track Your Order',
    trackSubtitle: 'Enter your order ID and the email you used at checkout.',
    trackOrderId: 'Order ID',
    trackBuyerEmail: 'Email used at checkout',
    trackSubmit: 'TRACK ORDER',
    trackFillBoth: 'Please fill in both order ID and email.',
    trackNotFound: "We couldn't find that order. Check the ID and email match your confirmation.",
    trackStage_placed: 'Placed',
    trackStage_confirmed: 'Confirmed',
    trackStage_shipped: 'Shipped',
    trackStage_delivered: 'Delivered',
    trackShipmentDetails: 'SHIPMENT DETAILS',
    trackCourier: 'Courier',
    trackNumber: 'Tracking Number',
    trackEta: 'Estimated Delivery',
    trackNotes: 'Notes',
    trackOpenCourier: 'Open courier site',
    trackNoDetailsYet: 'Tracking details will appear here once your order is shipped.'
  },
  de: {
    men: 'HERREN', women: 'DAMEN', sneakers: 'SNEAKER',
    account: 'Konto', wishlist: 'Wunschliste', bag: 'Warenkorb',
    searchPlaceholder: 'Wonach suchen Sie?',
    theBrand: 'DER', brandName: 'FERON STORE',
    topwear: 'OBERTEILE', bottomwear: 'UNTERTEILE', footwear: 'SCHUHE', accessories: 'ACCESSOIRES', shopByStyle: 'NACH STIL EINKAUFEN', collections: 'KOLLEKTIONEN',
    offer1: 'KOSTENLOSER WELTWEITER VERSAND',
    offer2: 'SICHERE ZAHLUNG',
    offer3: '30 TAGE RÜCKGABERECHT',
    offer4: '3 KAUFEN, 20% RABATT | CODE: FERON20',
    presents: 'FERON STORE PRÄSENTIERT',
    heroGrandTitle: 'GROẞE ERÖFFNUNG', heroGrandSub: 'Willkommen zu einem neuen Anfang — entdecke das brandneue Feron-Einkaufserlebnis.', heroGrandCta: 'JETZT SHOPPEN',
    hero1Title: 'DER GROßE WINTERSALE', hero1Sub: '', hero1Cta: 'JETZT KAUFEN',
    hero2Title: 'NEUE DROPS SIND DA', hero2Sub: 'Frische Styles direkt vom Laufsteg', hero2Cta: 'ENTDECKEN',
    hero3Title: 'STREETWEAR EDIT', hero3Sub: 'Beherrsche die Straßen', hero3Cta: 'EDIT KAUFEN',
    shopByCategory: 'NACH KATEGORIE EINKAUFEN',
    newArrivals: 'NEUHEITEN', bestSellers: 'BESTSELLER', sneakerDrop: 'SNEAKER DROP',
    viewAll: 'ALLE ANZEIGEN',
    officialMerch: 'OFFIZIELLE MERCHANDISE',
    officialMerchSub: 'Lizenzierte Kollaborationen mit den größten Marken der Welt',
    off: 'RABATT', products: 'Produkte',
    filters: 'FILTER', category: 'KATEGORIE', price: 'PREIS', discount: 'RABATT',
    upTo: 'bis zu', min: 'min.',
    clearAll: 'ALLES LÖSCHEN',
    sortLabel: 'Sortieren',
    sortPopular: 'Beliebtheit', sortNew: 'Was gibt\'s Neues', sortPlh: 'Preis: Aufsteigend', sortPhl: 'Preis: Absteigend', sortDisc: 'Rabatt',
    noProducts: 'Keine Produkte gefunden. Filter anpassen.',
    searchResults: 'Suche',
    mensCollection: 'HERRENKOLLEKTION', womensCollection: 'DAMENKOLLEKTION', shopAll: 'ALLES EINKAUFEN',
    home: 'Startseite', reviews: 'Bewertungen',
    inclTaxes: 'Inkl. aller Steuern',
    selectSize: 'GRÖßE WÄHLEN', sizeChart: 'GRÖßENTABELLE',
    addToBag: 'IN DEN WARENKORB', wishlistBtn: 'WUNSCHLISTE',
    pleaseSelectSize: 'Bitte wählen Sie eine Größe',
    checkDelivery: 'LIEFERUNG PRÜFEN', enterPincode: 'PLZ eingeben', checkBtn: 'PRÜFEN',
    deliveryOk: 'Lieferung an {pin} in {days} Werktagen.',
    invalidPin: 'Bitte gültige 5-6-stellige PLZ eingeben',
    freeShipping: 'Kostenloser Versand', dayReturns: '30 Tage Rückgabe', securePayments: 'Sichere Zahlung',
    productDetails: 'PRODUKTDETAILS',
    fabric: 'Stoff: 100% Baumwolle', fit: 'Passform: Oversized', pattern: 'Muster: Bedruckt', washCare: 'Pflege: Kaltwaschen, niedrige Trocknung',
    youMayLike: 'KÖNNTE IHNEN AUCH GEFALLEN',
    productNotFound: 'Produkt nicht gefunden.', goHome: 'Zur Startseite',
    myBag: 'MEIN WARENKORB', items: 'Artikel',
    emptyBag: 'Ihr Warenkorb ist leer', emptyBagSub: 'Fügen Sie coole Sachen hinzu, um loszulegen',
    continueShopping: 'WEITER EINKAUFEN',
    freeShipTag: 'Juhu! Sie erhalten KOSTENLOSEN VERSAND', addForFreeShip: 'Noch {amount} für kostenlosen Versand',
    size: 'Größe', remove: 'ENTFERNEN',
    priceDetails: 'PREISDETAILS', totalMrp: 'Gesamt UVP', discountMrp: 'Rabatt auf UVP',
    couponDiscount: 'Gutschein-Rabatt', shipping: 'Versand', free: 'GRATIS',
    totalAmount: 'Gesamtbetrag', savingMsg: 'Sie sparen {amount} bei dieser Bestellung',
    couponPlaceholder: 'Gutschein eingeben (FERON20)', apply: 'ANWENDEN',
    couponApplied: 'Gutschein angewendet!', savedAmount: 'Sie haben {amount} gespart', invalidCoupon: 'Ungültiger Gutschein',
    placeOrder: 'BESTELLUNG AUFGEBEN',
    checkoutDemo: 'Checkout-Demo', checkoutDemoSub: 'Dies ist eine Frontend-Demo. Backend-Checkout kommt bald.',
    myWishlist: 'MEINE WUNSCHLISTE',
    emptyWishlist: 'Ihre Wunschliste ist leer', emptyWishlistSub: 'Speichern Sie hier Ihre Favoriten für später',
    explore: 'PRODUKTE ENTDECKEN',
    addedToBag: 'Zum Warenkorb hinzugefügt', addedToWishlist: 'Zur Wunschliste hinzugefügt', removedFromWishlist: 'Aus Wunschliste entfernt',
    welcomeTo: 'WILLKOMMEN BEI',
    loginSubtitle: 'Anmelden / Registrieren mit Handynummer',
    mobileNumber: 'HANDYNUMMER', mobilePlaceholder: '10-stellige Nummer',
    sendOtp: 'OTP SENDEN', enterOtp: 'OTP EINGEBEN (beliebige 4 Ziffern)', verifyLogin: 'BESTÄTIGEN & ANMELDEN',
    changeNumber: 'Nummer ändern',
    termsText: 'Mit Fortfahren stimme ich den Nutzungsbedingungen und der Datenschutzrichtlinie von Feron Store zu',
    myAccount: 'Mein Konto', welcomeBack: 'Willkommen zurück,', logout: 'Abmelden',
    needHelp: 'HILFE', company: 'UNTERNEHMEN', moreInfo: 'MEHR INFO', storeNearMe: 'STORE IN DER NÄHE',
    contactUs: 'Kontakt', trackOrder: 'Bestellung verfolgen', returnsRefunds: 'Umtausch', faqs: 'Häufige Fragen', myAccountLink: 'Mein Konto',
    aboutUs: 'Über uns', investorRelation: 'Investor Relations', careers: 'Karriere', giftVouchers: 'Geschenkgutscheine', community: 'Gemeinschaftsinitiativen',
    tnc: 'AGB', privacyPolicy: 'Datenschutz', sitemap: 'Sitemap', getNotified: 'Benachrichtigen', blogs: 'Blogs',
    viewMore: 'Mehr anzeigen',
    codAvailable: 'Sichere Zahlung', easyReturns: '30 Tage Rückgabe', freeShippingOver: 'Kostenloser Versand ab {amount}', freeShippingWorldwide: 'Kostenloser weltweiter Versand', experienceApp: 'Feron App erleben',
    copyright: '© 2025 Feron Store. Alle Rechte vorbehalten.',
    vatIncluded: 'MwSt. ({rate}%) inklusive · Preise in EUR', vatLine: 'inkl. MwSt. ({rate}%)',
    country: 'Land', language: 'Sprache', currency: 'Währung', save: 'Speichern',
    // care instructions
    careByLine: 'VON ASENA & HITVANSHI',
    careThankYou: 'Danke, dass Sie sich für unsere Kleidung entschieden haben und in Ihre Superhelden-Kraft schlüpfen — Ihr Stil ist Ihre Superstärke! Jeder Kauf hilft Ihnen, die Welt mit Selbstvertrauen und Mut zu erobern, und wir sind geehrt, Teil Ihrer heldenhaften Reise zu sein.',
    careInstructions: 'PFLEGEHINWEISE',
    careTagline: 'Bitte befolgen Sie diese Hinweise, damit das Kleidungsstück in gutem Zustand bleibt',
    care_coldWash: 'Kaltwäsche',
    care_noBleach: 'Nicht bleichen',
    care_noTumble: 'Nicht im Trockner trocknen',
    care_ironMedium: 'Bei mittlerer Hitze bügeln',
    care_coldMachine: 'Kalt in der Maschine waschen',
    care_noIronPrint: 'Druck oder Stickerei nicht bügeln',
    careFooterLeft: 'Werten Sie Ihren Alltag mit FERON auf'
  },

  fr: {
    men: 'HOMMES', women: 'FEMMES', sneakers: 'BASKETS',
    account: 'Compte', wishlist: 'Favoris', bag: 'Panier',
    searchPlaceholder: 'Que cherchez-vous ?',
    theBrand: 'LE', brandName: 'FERON STORE',
    topwear: 'HAUTS', bottomwear: 'BAS', footwear: 'CHAUSSURES', accessories: 'ACCESSOIRES', shopByStyle: 'PAR STYLE', collections: 'COLLECTIONS',
    offer1: 'LIVRAISON GRATUITE PARTOUT',
    offer2: 'PAIEMENT SÉCURISÉ',
    offer3: '30 JOURS POUR ÉCHANGER OU RETOURNER',
    offer4: '3 ACHETÉS, 20% DE RÉDUCTION | CODE : FERON20',
    presents: 'FERON STORE PRÉSENTE',
    heroGrandTitle: 'GRANDE OUVERTURE', heroGrandSub: 'Bienvenue dans un nouveau départ — découvrez la toute nouvelle expérience Feron.', heroGrandCta: 'COMMENCER',
    hero1Title: 'GRANDES SOLDES D\'HIVER', hero1Sub: '', hero1Cta: 'ACHETER',
    hero2Title: 'NOUVEAUTÉS EN LIGNE', hero2Sub: 'Styles frais tout droit du podium', hero2Cta: 'EXPLORER',
    hero3Title: 'STREETWEAR EDIT', hero3Sub: 'Régnez sur la rue', hero3Cta: 'DÉCOUVRIR',
    shopByCategory: 'ACHETER PAR CATÉGORIE',
    newArrivals: 'NOUVEAUTÉS', bestSellers: 'MEILLEURES VENTES', sneakerDrop: 'DROP BASKETS',
    viewAll: 'TOUT VOIR',
    officialMerch: 'MERCHANDISING OFFICIEL',
    officialMerchSub: 'Collaborations sous licence avec les plus grandes marques',
    off: 'RÉDUCTION', products: 'produits',
    filters: 'FILTRES', category: 'CATÉGORIE', price: 'PRIX', discount: 'REMISE',
    upTo: 'jusqu\'à', min: 'min',
    clearAll: 'TOUT EFFACER',
    sortLabel: 'Trier',
    sortPopular: 'Popularité', sortNew: 'Nouveautés', sortPlh: 'Prix : croissant', sortPhl: 'Prix : décroissant', sortDisc: 'Remise',
    noProducts: 'Aucun produit trouvé. Ajustez les filtres.',
    searchResults: 'Recherche',
    mensCollection: 'COLLECTION HOMMES', womensCollection: 'COLLECTION FEMMES', shopAll: 'TOUT ACHETER',
    home: 'Accueil', reviews: 'avis',
    inclTaxes: 'Toutes taxes incluses',
    selectSize: 'CHOISIR LA TAILLE', sizeChart: 'GUIDE DES TAILLES',
    addToBag: 'AJOUTER AU PANIER', wishlistBtn: 'FAVORIS',
    pleaseSelectSize: 'Veuillez sélectionner une taille',
    checkDelivery: 'VÉRIFIER LA LIVRAISON', enterPincode: 'Entrez le code postal', checkBtn: 'VÉRIFIER',
    deliveryOk: 'Livraison à {pin} en {days} jours ouvrés.',
    invalidPin: 'Veuillez entrer un code postal valide',
    freeShipping: 'Livraison gratuite', dayReturns: 'Retours sous 30 jours', securePayments: 'Paiement sécurisé',
    productDetails: 'DÉTAILS DU PRODUIT',
    fabric: 'Tissu : 100% coton', fit: 'Coupe : oversize', pattern: 'Motif : imprimé', washCare: 'Entretien : lavage à froid, séchage doux',
    youMayLike: 'VOUS AIMEREZ PEUT-ÊTRE AUSSI',
    productNotFound: 'Produit introuvable.', goHome: 'Retour à l\'accueil',
    myBag: 'MON PANIER', items: 'articles',
    emptyBag: 'Votre panier est vide', emptyBagSub: 'Ajoutez des articles pour commencer',
    continueShopping: 'CONTINUER MES ACHATS',
    freeShipTag: 'Super ! Livraison GRATUITE offerte', addForFreeShip: 'Ajoutez {amount} pour la livraison gratuite',
    size: 'Taille', remove: 'RETIRER',
    priceDetails: 'DÉTAILS DU PRIX', totalMrp: 'Prix total', discountMrp: 'Remise appliquée',
    couponDiscount: 'Remise coupon', shipping: 'Livraison', free: 'GRATUIT',
    totalAmount: 'Total à payer', savingMsg: 'Vous économisez {amount} sur cette commande',
    couponPlaceholder: 'Code promo (essayez FERON20)', apply: 'APPLIQUER',
    couponApplied: 'Code appliqué !', savedAmount: 'Vous avez économisé {amount}', invalidCoupon: 'Code invalide',
    placeOrder: 'PASSER COMMANDE',
    checkoutDemo: 'Démo checkout', checkoutDemoSub: 'Ceci est une démo frontend. Le checkout backend arrive bientôt.',
    myWishlist: 'MES FAVORIS',
    emptyWishlist: 'Votre liste de favoris est vide', emptyWishlistSub: 'Sauvegardez vos coups de cœur ici',
    explore: 'DÉCOUVRIR LES PRODUITS',
    addedToBag: 'Ajouté au panier', addedToWishlist: 'Ajouté aux favoris', removedFromWishlist: 'Retiré des favoris',
    welcomeTo: 'BIENVENUE CHEZ',
    loginSubtitle: 'Connexion / Inscription avec votre numéro',
    mobileNumber: 'NUMÉRO DE PORTABLE', mobilePlaceholder: 'Numéro à 10 chiffres',
    sendOtp: 'ENVOYER OTP', enterOtp: 'ENTREZ OTP (4 chiffres)', verifyLogin: 'VÉRIFIER ET SE CONNECTER',
    changeNumber: 'Changer le numéro',
    termsText: 'En continuant, j\'accepte les Conditions d\'utilisation et la Politique de confidentialité de Feron Store',
    myAccount: 'Mon Compte', welcomeBack: 'Bon retour,', logout: 'Déconnexion',
    needHelp: 'AIDE', company: 'SOCIÉTÉ', moreInfo: 'PLUS D\'INFOS', storeNearMe: 'BOUTIQUE PROCHE',
    contactUs: 'Nous contacter', trackOrder: 'Suivre la commande', returnsRefunds: 'Échanges', faqs: 'FAQ', myAccountLink: 'Mon Compte',
    aboutUs: 'À propos', investorRelation: 'Relations investisseurs', careers: 'Carrières', giftVouchers: 'Cartes cadeau', community: 'Initiatives communautaires',
    tnc: 'CGV', privacyPolicy: 'Confidentialité', sitemap: 'Plan du site', getNotified: 'Être notifié', blogs: 'Blogs',
    viewMore: 'Voir plus',
    codAvailable: 'Paiement sécurisé', easyReturns: 'Retours sous 30 jours', freeShippingOver: 'Livraison gratuite dès {amount}', freeShippingWorldwide: 'Livraison gratuite partout', experienceApp: 'Découvrir l\'app Feron',
    copyright: '© 2025 Feron Store. Tous droits réservés.',
    vatIncluded: 'TVA ({rate}%) incluse · Prix en EUR', vatLine: 'TVA ({rate}%) incluse',
    country: 'Pays', language: 'Langue', currency: 'Devise', save: 'Enregistrer',
    // care instructions
    careByLine: 'PAR ASENA & HITVANSHI',
    careThankYou: 'Merci d\'avoir choisi nos vêtements et d\'incarner votre puissance de super-héros — votre style est votre super-force ! Chaque achat vous aide à conquérir le monde avec confiance et courage, et nous sommes honorés de faire partie de votre parcours héroïque.',
    careInstructions: 'ENTRETIEN',
    careTagline: 'Veuillez suivre ces conseils pour que le vêtement reste en bon état',
    care_coldWash: 'Lavage à froid',
    care_noBleach: 'Ne pas blanchir',
    care_noTumble: 'Ne pas mettre au sèche-linge',
    care_ironMedium: 'Repasser à chaleur moyenne',
    care_coldMachine: 'Lavage machine à froid',
    care_noIronPrint: 'Ne pas repasser sur imprimé ou broderie',
    careFooterLeft: 'Sublimez votre quotidien avec FERON'
  },

  es: {
    men: 'HOMBRE', women: 'MUJER', sneakers: 'ZAPATILLAS',
    account: 'Cuenta', wishlist: 'Favoritos', bag: 'Cesta',
    searchPlaceholder: '¿Qué estás buscando?',
    theBrand: 'LA', brandName: 'FERON STORE',
    topwear: 'PARTE SUPERIOR', bottomwear: 'PARTE INFERIOR', footwear: 'CALZADO', accessories: 'ACCESORIOS', shopByStyle: 'COMPRAR POR ESTILO', collections: 'COLECCIONES',
    offer1: 'ENVÍO GRATIS EN TODO EL MUNDO',
    offer2: 'PAGOS SEGUROS',
    offer3: '30 DÍAS PARA DEVOLUCIONES Y CAMBIOS',
    offer4: '3 x 20% DE DESCUENTO | CÓDIGO: FERON20',
    presents: 'FERON STORE PRESENTA',
    heroGrandTitle: 'GRAN INAUGURACIÓN', heroGrandSub: 'Bienvenido a un nuevo comienzo — vive la nueva experiencia de compra Feron.', heroGrandCta: 'EMPEZAR A COMPRAR',
    hero1Title: 'LAS GRANDES REBAJAS DE INVIERNO', hero1Sub: '', hero1Cta: 'COMPRAR YA',
    hero2Title: 'NUEVAS LLEGADAS', hero2Sub: 'Estilos frescos directos de la pasarela', hero2Cta: 'EXPLORAR',
    hero3Title: 'STREETWEAR EDIT', hero3Sub: 'Domina la calle', hero3Cta: 'DESCUBRIR',
    shopByCategory: 'COMPRAR POR CATEGORÍA',
    newArrivals: 'NUEVAS LLEGADAS', bestSellers: 'MÁS VENDIDOS', sneakerDrop: 'DROP ZAPATILLAS',
    viewAll: 'VER TODO',
    officialMerch: 'MERCHANDISING OFICIAL',
    officialMerchSub: 'Colaboraciones licenciadas con las mayores marcas del mundo',
    off: 'DESCUENTO', products: 'productos',
    filters: 'FILTROS', category: 'CATEGORÍA', price: 'PRECIO', discount: 'DESCUENTO',
    upTo: 'hasta', min: 'mín.',
    clearAll: 'LIMPIAR TODO',
    sortLabel: 'Ordenar',
    sortPopular: 'Popularidad', sortNew: 'Novedades', sortPlh: 'Precio: menor a mayor', sortPhl: 'Precio: mayor a menor', sortDisc: 'Descuento',
    noProducts: 'No se encontraron productos. Ajusta los filtros.',
    searchResults: 'Buscar',
    mensCollection: 'COLECCIÓN HOMBRE', womensCollection: 'COLECCIÓN MUJER', shopAll: 'COMPRAR TODO',
    home: 'Inicio', reviews: 'reseñas',
    inclTaxes: 'Impuestos incluidos',
    selectSize: 'ELEGIR TALLA', sizeChart: 'GUÍA DE TALLAS',
    addToBag: 'AÑADIR A LA CESTA', wishlistBtn: 'FAVORITOS',
    pleaseSelectSize: 'Por favor selecciona una talla',
    checkDelivery: 'COMPROBAR ENTREGA', enterPincode: 'Introduce código postal', checkBtn: 'COMPROBAR',
    deliveryOk: 'Entrega en {pin} en {days} días laborables.',
    invalidPin: 'Introduce un código postal válido',
    freeShipping: 'Envío gratis', dayReturns: 'Devoluciones 30 días', securePayments: 'Pago seguro',
    productDetails: 'DETALLES DEL PRODUCTO',
    fabric: 'Tejido: 100% algodón', fit: 'Corte: oversize', pattern: 'Estampado: impreso', washCare: 'Cuidado: lavar en frío, secado suave',
    youMayLike: 'TAMBIÉN TE PUEDE GUSTAR',
    productNotFound: 'Producto no encontrado.', goHome: 'Ir al inicio',
    myBag: 'MI CESTA', items: 'artículos',
    emptyBag: 'Tu cesta está vacía', emptyBagSub: 'Añade productos para empezar',
    continueShopping: 'SEGUIR COMPRANDO',
    freeShipTag: '¡Genial! Tienes ENVÍO GRATIS', addForFreeShip: 'Añade {amount} más para envío gratis',
    size: 'Talla', remove: 'ELIMINAR',
    priceDetails: 'DETALLES DEL PRECIO', totalMrp: 'Total PVP', discountMrp: 'Descuento sobre PVP',
    couponDiscount: 'Descuento cupón', shipping: 'Envío', free: 'GRATIS',
    totalAmount: 'Total a pagar', savingMsg: 'Ahorras {amount} en este pedido',
    couponPlaceholder: 'Cupón (prueba FERON20)', apply: 'APLICAR',
    couponApplied: '¡Cupón aplicado!', savedAmount: 'Has ahorrado {amount}', invalidCoupon: 'Cupón no válido',
    placeOrder: 'REALIZAR PEDIDO',
    checkoutDemo: 'Demo de checkout', checkoutDemoSub: 'Esto es una demo frontend. El checkout backend llega pronto.',
    myWishlist: 'MIS FAVORITOS',
    emptyWishlist: 'Tu lista de favoritos está vacía', emptyWishlistSub: 'Guarda aquí tus prendas favoritas',
    explore: 'EXPLORAR PRODUCTOS',
    addedToBag: 'Añadido a la cesta', addedToWishlist: 'Añadido a favoritos', removedFromWishlist: 'Eliminado de favoritos',
    welcomeTo: 'BIENVENIDO A',
    loginSubtitle: 'Inicia sesión con tu número de móvil',
    mobileNumber: 'NÚMERO DE MÓVIL', mobilePlaceholder: 'Número de 10 dígitos',
    sendOtp: 'ENVIAR OTP', enterOtp: 'INTRODUCE OTP (4 dígitos)', verifyLogin: 'VERIFICAR E INICIAR SESIÓN',
    changeNumber: 'Cambiar número',
    termsText: 'Al continuar acepto los Términos y Política de Privacidad de Feron Store',
    myAccount: 'Mi Cuenta', welcomeBack: 'Bienvenido de nuevo,', logout: 'Cerrar sesión',
    needHelp: 'AYUDA', company: 'EMPRESA', moreInfo: 'MÁS INFO', storeNearMe: 'TIENDA CERCA',
    contactUs: 'Contacto', trackOrder: 'Seguir pedido', returnsRefunds: 'Cambios', faqs: 'FAQ', myAccountLink: 'Mi Cuenta',
    aboutUs: 'Sobre nosotros', investorRelation: 'Relaciones con inversores', careers: 'Empleo', giftVouchers: 'Tarjetas regalo', community: 'Iniciativas comunitarias',
    tnc: 'Términos', privacyPolicy: 'Privacidad', sitemap: 'Mapa del sitio', getNotified: 'Recibir avisos', blogs: 'Blog',
    viewMore: 'Ver más',
    codAvailable: 'Pagos seguros', easyReturns: '30 días de devolución', freeShippingOver: 'Envío gratis desde {amount}', freeShippingWorldwide: 'Envío gratis en todo el mundo', experienceApp: 'Descubre la app Feron',
    copyright: '© 2025 Feron Store. Todos los derechos reservados.',
    vatIncluded: 'IVA ({rate}%) incluido · Precios en EUR', vatLine: 'IVA ({rate}%) incl.',
    country: 'País', language: 'Idioma', currency: 'Moneda', save: 'Guardar',
    // care instructions
    careByLine: 'POR ASENA Y HITVANSHI',
    careThankYou: 'Gracias por elegir nuestra ropa y despertar tu poder de superhéroe: ¡tu estilo es tu súper fuerza! Cada compra que haces te ayuda a conquistar el mundo con confianza y valor, y es un honor formar parte de tu viaje heroico.',
    careInstructions: 'INSTRUCCIONES DE CUIDADO',
    careTagline: 'Sigue estos consejos para que la prenda se mantenga en buen estado',
    care_coldWash: 'Lavado en frío',
    care_noBleach: 'No usar lejía',
    care_noTumble: 'No secar en secadora',
    care_ironMedium: 'Planchar a temperatura media',
    care_coldMachine: 'Lavado a máquina en frío',
    care_noIronPrint: 'No planchar sobre estampado o bordado',
    careFooterLeft: 'Realza tu día a día con FERON'
  }
};

export function t(lang, key, vars = {}) {
  let s = (translations[lang] && translations[lang][key]) || translations.en[key] || key;
  Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
  return s;
}
